import React from "react";
import { useLocation, useParams } from "react-router-dom";

import {
  FormContainer,
  FormContainerItem,
  SuccessBanner,
} from "@graffer-inc/console-design-kit";

import { useServiceAccountDetailPage } from "../../../../hooks/service-account/service-account-detail";
import { parseQueryOfLocation } from "../../../../utils/url-utils";
import { ServiceAccountDetailContent } from "../../../organisms/service-account/service-account-detail-content/service-account-detail-content";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderR } from "../routes";

export const ServiceAccountDetailPage: React.FC = () => {
  const { tenantId, serviceAccountId } = useParams<{
    tenantId: string;
    serviceAccountId: string;
  }>();

  const { pageContent, createServiceAccountKey, updateServiceAccount } =
    useServiceAccountDetailPage({
      tenantId,
      serviceAccountId,
    });

  const { isNewlyCreated } = parseQueryOfLocation(useLocation());
  const [showNewlyCreatedBanner, setShowNewlyCreatedBanner] = React.useState(
    isNewlyCreated === "true",
  );

  return (
    <ServiceProviderTemplate
      breadcrumbs={[
        {
          to: ServiceProviderR.Home.link({}),
          title: "Home",
        },
        {
          to: ServiceProviderR.ServiceAccounts.link({ tenantId }),
          title: "サービスアカウント",
        },
        {
          to: ServiceProviderR.ServiceAccountDetail.link({
            tenantId,
            serviceAccountId,
          }),
          title: "詳細",
        },
      ]}
    >
      {showNewlyCreatedBanner && (
        <div className="mb-5">
          <NewlyCreatedBanner
            onClose={() => {
              setShowNewlyCreatedBanner(false);
            }}
          />
        </div>
      )}
      {!!pageContent && (
        <ServiceAccountDetailContent
          serviceAccount={pageContent.serviceAccount}
          serviceAccountKeys={pageContent.serviceAccountKeys}
          groups={pageContent.groups}
          onClickServiceAccountKeyCreate={createServiceAccountKey}
          onClickUpdateServiceAccount={updateServiceAccount}
          // 無効化は影響が大きい操作なので、いったんテナントユーザー限定とし、
          // ServiceProviderAccount は GUI からは実行できないようにする。
          onClickDisableServiceAccount={undefined}
          onClickDisableServiceAccountKey={undefined}
        />
      )}
    </ServiceProviderTemplate>
  );
};

const NewlyCreatedBanner: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  return (
    <FormContainer>
      <FormContainerItem>
        <SuccessBanner
          message="サービスアカウントを作成しました"
          onClose={onClose}
        />
      </FormContainerItem>
    </FormContainer>
  );
};
